var React = require('react');

function Playhead (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"75","height":"75","fill":"#161616","fillOpacity":"0.9","key":0}),React.createElement("path",{"d":"M30.0309 38V23.9691L49.0711 38L30.0309 52.0309V38Z","fill":"white","key":1})]);
}

Playhead.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = Playhead;

Playhead.default = Playhead;
